<!--此页面的pageNum为0 1 2和pageSource为true false-->
<!---其中this.pageNum = 1&& this.pageSource为true表示点击下钻进入的详情页-->
<!---其中this.pageNum = 2&& this.pageSource为true表示点击下钻详情页再下钻的页面-->
<!---其中this.pageNum = 1&& this.pageSource为false表示点击查看更多进入的详情页-->
<!---其中this.pageNum = 0&& this.pageSource为true表示进入的是结构分析的默认首页面-->
<template>
  <div>
    <el-row class="table-warpper">
      <el-col :span="12" class="table-title">结构分析</el-col>
      <el-col :span="12" class="table-icon">
        <div @click="showPopup">
          <img src="../../../../static/images/screen.png" style="width:.2rem;height:.2rem">
        </div>
        <van-popup v-model="show">
          <table-screens ref="screen" v-on:childByValue="childByValue" :timeIndex="timeIndex" :otherFiler="nameData" :typeData="typeData"></table-screens>
        </van-popup>
      </el-col>
    </el-row>
    <div :class="'curTable' + (childShow ? ' fixTop' : '')">
      <el-table
        ref="structureTable1"
        :span-method="objectSpanMethod"
        :data="showData"
        style="width: 100%"
        row-key="orgRiskId"
        :height="childShow ? popHeight : tableHeight"
        border
        lazy
        :load="load"
        v-loading="loading"
        @sort-change="sortProportion"
        :header-cell-class-name="handleTheadAddClass"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        class="table-itme tableList5">
        <el-table-column
          :key="Math.random()"
          prop="areaName"
          label="区"
          v-if="this.isHeadCompany() && childShow"
          type=""
          min-width="45"
          class="demo-table-expand widthStyle">
        </el-table-column>
        <el-table-column
          :key="Math.random()"
          prop="orgName"
          sortable='custom'
          label="机构"
          style="width: 20%"
          class="demo-table-expand">
        </el-table-column>
        <el-table-column
          :key="Math.random()"
          prop="riskTypeName"
          :label="nameData.riskTypeName"
          style="width: 20%"
          class="demo-table-expand">
        </el-table-column>
        <el-table-column
          :key="Math.random()"
          prop="reach"
          sortable='custom'
          style="width: 40%"
          :label="nameData.achievementName">
          <template slot-scope="scope">
            <div v-if="postQuota === 'A0202-1023'">
              <div v-if="scope.row.reach !== null">
                <span v-if="nameData.achievementName.indexOf('率')!==-1">{{ Math.round(scope.row.reach).toString().replace(/(\d{1,3})(?=(\d{3})+$)/g,'$1,') }}{{ nameData.achievementUnit }}</span>
                <span v-else>{{ Math.round(scope.row.reach).toString().replace(/(\d{1,3})(?=(\d{3})+$)/g,'$1,') }}</span>
              </div>
              <div v-else></div>
            </div>
            <div v-else>
              <div v-if="scope.row.reach !== null">
                <span v-if="nameData.achievementName.indexOf('率')!==-1">{{ Math.round(scope.row.reach).toString().replace(/(\d{1,3})(?=(\d{3})+$)/g,'$1,') }}{{ nameData.achievementUnit }}</span>
                <span v-else>{{ Math.round(scope.row.reach).toString().replace(/(\d{1,3})(?=(\d{3})+$)/g,'$1,') }}</span>
              </div>
              <div v-else>--</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :key="Math.random()"
          prop="proportion"
          sortable='custom'
          style="width: 25%"
          label="占比">
          <template slot-scope="scope">
            <div v-if="postQuota === 'A0202-1023'">
              <span v-if="scope.row.proportion !== null">{{scope.row.proportion}}%</span>
              <span v-else></span>
            </div>
            <div v-else>
              <span v-if="scope.row.proportion !== null">{{scope.row.proportion}}%</span>
              <span v-else>--%</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-row>
        <el-col v-if="isBack" :span="24"><div @click="backMore" class="more">返回</div></el-col>
       <el-col v-if="shouqi" :span="24"><div @click="back" class="more">收起</div></el-col>
        <el-col v-if="!childShow && !isBack" :span="24"><div @click="showMore" class="more">查看更多</div></el-col>
      </el-row>
    </div>
    <home-commonbg class="showImg" v-if="loadFlag"></home-commonbg>
  </div>
</template>

<script>
import HomeCommonbg from '../../common/commonBg'
import TableScreens from '../../common/analyseScreen/StructureScreen'
// import axios from 'axios'
import { postAction } from '@/utils/api'
export default {
  name: 'StructureTable',
  components: {
    TableScreens,
    HomeCommonbg
  },
  props: ['timeIndex', 'dateData'],
  data () {
    return {
      tableHeight: '',
      preArea: '',
      preOrgName: '',
      oneCopy: null,
      show: false,
      moreFlag: null,
      listData: [],
      showData: [],
      isProduct: false,
      moreText: '查看更多',
      showTabledata: [], // 最终展示数据
      tableDataAny: [], // 带合计行的数据
      tableAddArea: [], // 东西南北四区数据
      tableData: [],
      tableDataSortByOrgCode: [], // 35加机构按照机构编码升序
      showMoreType: 1,
      pageNum: 0, // 页面层级 0为默认产品分析页面，1为查看更多和下钻页面 2为分公司中支下钻页面
      pageSource: true, // false 代表查看更多进入，true代表下钻进入
      loading: '',
      getData: '',
      nameData: {},
      typeData: [],
      firstLevel: [], // 筛选中的一级数据
      reachObj: null,
      compareObj: null,
      selectCode: '',
      selectType: '',
      postChannel: '',
      postKind: '',
      postQuota: '',
      popData: null,
      popHeight: '',
      isShow: false,
      childTable: [],
      childShow: false,
      sortData: [],
      typeLength: '',
      typeLengthArr: [],
      curThead: '',
      sequenceOrder: null, // 表格列排序的顺序 ascending 正序 descending 倒序 null 默认
      loadFlag: false,
      showDataStack: [],
      totalRows: [],
      isLoadInto: false, // 是否为分公司下钻
      isBack: false, // 是否显示返回
      shouqi: false // 是否展示收起
    }
  },
  methods: {
    sortProportion (column) {
      this.curThead = column.prop
      // 升降序箭头样式
      if (column.order === 'ascending') {
        // 降序箭头高亮
        setTimeout(() => { $('.active-thead .sort-caret.ascending').css({'borderBottomColor': '#409eff'}) }, 200)
      }
      if (column.order === 'descending') {
        setTimeout(() => { $('.active-thead .sort-caret.descending').css({'borderTopColor': '#409eff'}) }, 200)
      }
      this.tableSort(column.prop, column.order)
    },
    tableSort (colData, flagData) {
      console.log(this.pageNum)
      console.log(this.pageSource)
      let result = this.getTableData()
      switch (colData) {
        // 点击机构列排序
        case 'orgName':
          this.one = JSON.parse(JSON.stringify(this.oneCopy))
          if (flagData === 'ascending') { // 升序
            // 中支数据不用按照先排区达成再按照机构排序
            if (this.pageNum === 2) {
              // if (this.pageSource === false) {
              //   result = this.one.concat(result.sort((a, b) => a.orgCode - b.orgCode))
              // }
              result = result.sort((a, b) => a.orgCode - b.orgCode)
              this.rowSpanFormatData(result) // 合并单元格
              return
            } else if (this.pageNum === 0) {
              result = this.realignSortArr(this.dealSortArr(result).reverse()).sort((a, b) => a.orgCode - b.orgCode)
            } else {
              // 按照区达成降序 在按照机构代码升序 ，类型不变
              result = (this.orderByAreaReachAndOrgCode(result, true))
            }
            if ((this.pageNum === 2 && this.pageSource === true) || (this.pageNum === 1 && this.pageSource === false) || (this.pageNum === 0 && this.pageSource === true)) {
              result = (this.orderByAreaReachAndOrgCode(result, true))
            } else {
              result = this.one.concat(this.orderByAreaReachAndOrgCode(result, true))
            }
            if (this.pageNum === 2 && this.pageSource === false) {
              result = (this.orderByAreaReachAndOrgCode(result, true))
            }
            if (this.pageSource === false) { // 查看更多
              result = this.one.concat(result.sort((a, b) => a.orgCode - b.orgCode))
            }
            this.rowSpanFormatData(result)
          } else if (flagData === 'descending') { // 降序
            if (this.pageSource === false && this.pageNum !== 2) {
              result = this.one.concat(result.sort((a, b) => b.orgCode - a.orgCode))
            } else if (this.pageNum === 0) {
              result = this.realignSortArr(this.dealSortArr(result).reverse()).sort((a, b) => b.orgCode - a.orgCode)
            } else {
              result = (this.orderByAreaReachAndOrgCode(result, false))
            }
            if ((this.pageNum === 2 && this.pageSource === true) || (this.pageNum === 1 && this.pageSource === false) || (this.pageNum === 2 && this.pageSource === false) || (this.pageNum === 0 && this.pageSource === true)) {
              result = this.orderByAreaReachAndOrgCode(result, false)
            } else {
              result = this.one.concat(this.orderByAreaReachAndOrgCode(result, false))
            }
            this.rowSpanFormatData(result) // 合并单元格
          } else { // 默认
            this.rowSpanFormatData(result) // 合并单元格
          }
          break
          // 点击达成列进行排序
        case 'reach':
          this.one = JSON.parse(JSON.stringify(this.oneCopy))
          if (flagData === 'ascending') { // 升序
            if (this.pageSource === false) { // false表示查看更多进入
              // 点击达成升序先按照类型排序在按照同类型达成升序排序
              if (this.pageNum === 0 || this.pageNum === 2) {
                result = this.reachTable(result, true)
              } else {
                result = this.one.concat(this.reachTable(result, true)) // 带合计行二级机构页面
              }
            } else {
              if (this.isHeadCompany()) {
                if (this.pageNum === 0) {
                  // 先按类型排序 再按照达成排序
                  result = this.reachTable(result, true)
                } else {
                  result = (this.reachOrgCodeAndType(result, true))
                }
                // 除去默认页面的其他详情页面达成指标排序均按照先区排序--类型排序--达成值升降排序规则reachOrgCodeAndType()方法
                if ((this.pageNum === 2 && this.pageSource === true) || (this.pageNum === 2 && this.pageSource === false)) {
                  result = (this.reachOrgCodeAndType(result, true))
                // 默认页面达成指标按先按照类型排即趸交-3年以下-3-4年-5-9年-10年以上再按照达成值升降排规则reachTable()方法
                } else if ((this.pageNum === 0 && this.pageSource === true)) {
                  result = (this.reachTable(result, true))
                } else {
                  result = this.one.concat(this.reachOrgCodeAndType(result, true))
                }
              } else {
                result = this.reachTable(result, true)
              }
            }
            this.rowSpanFormatData(result) // 合并单元格
          } else if (flagData === 'descending') { // 降序
            if (this.pageSource === false && this.pageNum === 1) {
              result = this.one.concat(this.reachTable(result, false))
            } else {
              if (this.isHeadCompany()) {
                if (this.pageNum === 0) {
                  // 先按类型排序 再按照达成排序
                  result = this.reachTable(result, false)
                } else {
                  result = (this.reachOrgCodeAndType(result, false))
                }
                // 除去默认页面的其他详情页面达成指标排序均按照先区排序--类型排序--达成值升降排序规则reachOrgCodeAndType()方法
                if ((this.pageNum === 2 && this.pageSource === true) || (this.pageNum === 2 && this.pageSource === false)) {
                  result = (this.reachOrgCodeAndType(result, false))
                  // 默认页面达成指标按先按照类型排即趸交-3年以下-3-4年-5-9年-10年以上再按照达成值升降排规则reachTable()方法
                } else if ((this.pageNum === 0 && this.pageSource === true)) {
                  result = (this.reachTable(result, false))
                } else {
                  result = this.one.concat(this.reachOrgCodeAndType(result, false))
                }
              } else {
                result = this.reachTable(result, false)
              }
            }
            this.rowSpanFormatData(result) // 合并单元格
          } else { // 默认
            this.rowSpanFormatData(result) // 合并单元格
          }
          break
          // 点击占比列进行排序
        case 'proportion':
          if (flagData === 'ascending') { // 升序
            this.one = JSON.parse(JSON.stringify(this.oneCopy))
            // var result = null
            if (this.pageSource === false) {
              // 非总公司、区总 占比用当前分公司数据排序
              if (this.pageNum === 2) {
                result = this.realignSortArr(this.proportionRealignArr(this.dealSortArr(result), true))
              } else {
                // let arrTableAny = this.tableDataAny.slice(4, this.tableDataAny.length)
                // result = this.one.concat(this.realignSortArr(this.proportionRealignArr(this.dealSortArr(result), true)))
                result = result.sort((a, b) => {
                  if (b.orgCode !== a.orgCode) {
                    return a.orgCode - b.orgCode
                  } else {
                    return b.proportion - a.proportion
                  }
                })
                this.one = this.one.sort((a, b) => {
                  return a.proportion - b.proportion
                })
                result = this.one.concat(this.realignSortArr(this.proportionRealignArr(this.dealSortArr(result), true)))
              }
            } else {
              // 结构分析首页
              if (this.pageNum === 0) {
                // 默认展示四区占比升序排列
                result = this.realignSortArr(this.proportionRealignArr(this.dealSortArr(result), true))
              } else {
                result = (this.realignSortArr(this.proportionRealignArr(this.dealSortArr(result), true)))
              }
              if ((this.pageNum === 2 && this.pageSource === true) || (this.pageNum === 2 && this.pageSource === false) || (this.pageNum === 0 && this.pageSource === true)) {
                result = (this.realignSortArr(this.proportionRealignArr(this.dealSortArr(result), true)))
              } else {
                this.one = this.one.sort((a, b) => {
                  return a.proportion - b.proportion
                })
                result = this.one.concat(this.realignSortArr(this.proportionRealignArr(this.dealSortArr(result), true)))
              }
            }
            this.rowSpanFormatData(result)
          } else if (flagData === 'descending') { // 降序
            this.one = JSON.parse(JSON.stringify(this.oneCopy))
            if (this.pageSource === false) {
              // 非总公司、区总 占比用当前分公司数据排序
              if (this.pageNum === 2) {
                result = this.realignSortArr(this.proportionRealignArr(this.dealSortArr(result), false))
              } else {
                // let arrTableAny = this.tableDataAny.slice(4, this.tableDataAny.length)
                result = result.sort((a, b) => {
                  if (b.orgCode !== a.orgCode) {
                    return a.orgCode - b.orgCode
                  } else {
                    return b.proportion - a.proportion
                  }
                })
                this.one = this.one.sort((a, b) => {
                  return b.proportion - a.proportion
                })
                result = this.one.concat(this.realignSortArr(this.proportionRealignArr(this.dealSortArr(result), false)))
              }
            } else {
              // result = (this.realignSortArr(this.proportionRealignArr(this.dealSortArr(result), false)))
              // 结构分析首页
              if (this.pageNum === 0) {
                result = this.realignSortArr(this.proportionRealignArr(this.dealSortArr(result), false))
              } else {
                result = (this.realignSortArr(this.proportionRealignArr(this.dealSortArr(result), false)))
              }
              if ((this.pageNum === 2 && this.pageSource === true) || (this.pageNum === 2 && this.pageSource === false) || (this.pageNum === 0 && this.pageSource === true)) {
                result = (this.realignSortArr(this.proportionRealignArr(this.dealSortArr(result), false)))
              } else {
                this.one = this.one.sort((a, b) => {
                  return b.proportion - a.proportion
                })
                result = this.one.concat(this.realignSortArr(this.proportionRealignArr(this.dealSortArr(result), false)))
              }
            }
            this.rowSpanFormatData(result) // 合并单元格
          } else { // 默认
            this.rowSpanFormatData(result) // 合并单元格
          }
          break
        default:
          this.rowSpanFormatData(result)
      }
    },
    // 先按照区达成排序再按照机构代码排序 order 机构代码正序 false 机构代码降序
    orderByAreaReachAndOrgCode (result, order = true) {
      let arrdata = []
      // 先按照区达成降序再按照类型排序
      let areaSort = new Set([])
      result.forEach(item => {
        return areaSort.add(item.areaCode)
      })
      let arraySourt = Array.from(areaSort)
      for (let index = 0; index < arraySourt.length; index++) {
        let areaList = JSON.parse(JSON.stringify(result.filter(area => area.areaCode === arraySourt[index])))
        if (order) {
          areaList.sort((a, b) => a.orgCode - b.orgCode)
        } else {
          areaList.sort((a, b) => b.orgCode - a.orgCode)
        }
        arrdata = arrdata.concat(areaList)
      }
      return arrdata
    },
    getTableData () {
      let result = []
      result = JSON.parse(JSON.stringify(this.tableData))
      // 默认pageNum = 0 显示四区界面数据tableAddArea
      if (this.isHeadCompany()) {
        switch (this.pageNum) {
          case 0:
            result = JSON.parse(JSON.stringify(this.tableAddArea))
            break
          case 1:
            // 默认下钻
            if (this.pageSource) {
              result = JSON.parse(JSON.stringify(this.tableData))
            } else {
              // 查看更多
              result = JSON.parse(JSON.stringify(this.tableData))
            }
            break
          case 2:
            // 默认下钻
            if (this.pageSource) {
              result = JSON.parse(JSON.stringify(this.childTable))
            } else {
              // 查看更多
              result = JSON.parse(JSON.stringify(this.childTable))
            }
            break
          default:
            result = JSON.parse(JSON.stringify(this.tableData))
        }
        // 总公司区总获取系统合计行，分公司中支合计行为[]
        this.one.forEach(element => {
          if (element.isTotalLine === '1') {
            element.areaName = ' '
          }
        })
      } else {
        this.one = []
        // 如果为分公司
        if (this.pageNum === 2 && !this.pageSource) {
          result = this.childTable
        }
        if (this.pageNum === 0 && this.isLoadInto) {
          result = this.childTable
        }
      }
      return result
    },
    // 先按机构代码排序，再按照类型排序 arr 需要排序的内容 order true 正序，false 倒序。 类型不参与排序
    reachOrgCodeAndType (arr, order = false) {
      let arrdata = []
      // 根据结构类型进行分类
      let areaSort = new Set([])
      arr.forEach(item => {
        return areaSort.add(item.areaCode)
      })
      let arraySourt = Array.from(areaSort)
      for (let index = 0; index < arraySourt.length; index++) {
        let test = JSON.parse(JSON.stringify(arr))
        // 过滤区信息
        let filterResult = test.filter(item => item.areaCode === arraySourt[index])
        // 将区内的数据按照类型进行排序
        this.typeData.forEach(typeDataRow => {
          if (order) {
            arrdata = arrdata.concat(filterResult.filter(item => item.riskTypeCode === typeDataRow.code).sort((a, b) => a.reach - b.reach))
          } else {
            arrdata = arrdata.concat(filterResult.filter(item => item.riskTypeCode === typeDataRow.code).sort((a, b) => b.reach - a.reach))
          }
        })
      }
      return arrdata
    },
    // 点击下钻 表格数据 先按照区排序 再按类型排序
    reachTableSortByArea (order) {
      // 对每个类型的数组按照类型指标riskTypeCode进行单个过滤之后进行sort排序,
      // A1,a1Arr表示人寿险，A2，a2Arr表示年金险，A3,a3Arr表示健康险，A4,a4Arr表示意外险
      let tableDataArr = []
      if (this.isHeadCompany()) {
        tableDataArr = this.showTabledata
      } else {
        tableDataArr = this.showData
      }
      // 根据区排序后 结果
      var a1Arr = tableDataArr.filter(item => item.areaCode === 861)
      // 1区
      var a1a1 = a1Arr.filter(item => item.riskTypeCode === 'C1').sort((a, b) => a.reach - b.reach)
      var a1a2 = a1Arr.filter(item => item.riskTypeCode === 'C2').sort((a, b) => a.reach - b.reach)
      var a1a3 = a1Arr.filter(item => item.riskTypeCode === 'C3').sort((a, b) => a.reach - b.reach)
      var a1a4 = a1Arr.filter(item => item.riskTypeCode === 'C4').sort((a, b) => a.reach - b.reach)
      var a1a5 = a1Arr.filter(item => item.riskTypeCode === 'C5').sort((a, b) => a.reach - b.reach)
      var a1ArrResult = a1a2.concat(a1a3, a1a1, a1a4, a1a5)
      // 2区
      var a2Arr = tableDataArr.filter(item => item.areaCode === 862)
      var a2a1 = a2Arr.filter(item => item.riskTypeCode === 'C1').sort((a, b) => a.reach - b.reach)
      var a2a2 = a2Arr.filter(item => item.riskTypeCode === 'C2').sort((a, b) => a.reach - b.reach)
      var a2a3 = a2Arr.filter(item => item.riskTypeCode === 'C3').sort((a, b) => a.reach - b.reach)
      var a2a4 = a2Arr.filter(item => item.riskTypeCode === 'C4').sort((a, b) => a.reach - b.reach)
      var a2a5 = a2Arr.filter(item => item.riskTypeCode === 'C5').sort((a, b) => a.reach - b.reach)
      var a2ArrResult = a2a2.concat(a2a3, a2a1, a2a4, a2a5)
      // 3区
      var a3Arr = tableDataArr.filter(item => item.areaCode === 863)
      var a3a1 = a3Arr.filter(item => item.riskTypeCode === 'C1').sort((a, b) => a.reach - b.reach)
      var a3a2 = a3Arr.filter(item => item.riskTypeCode === 'C2').sort((a, b) => a.reach - b.reach)
      var a3a3 = a3Arr.filter(item => item.riskTypeCode === 'C3').sort((a, b) => a.reach - b.reach)
      var a3a4 = a3Arr.filter(item => item.riskTypeCode === 'C4').sort((a, b) => a.reach - b.reach)
      var a3a5 = a3Arr.filter(item => item.riskTypeCode === 'C5').sort((a, b) => a.reach - b.reach)
      var a3ArrResult = a3a2.concat(a3a3, a3a1, a3a4, a3a5)
      // 4区
      var a4Arr = tableDataArr.filter(item => item.areaCode === 864)
      var a4a1 = a4Arr.filter(item => item.riskTypeCode === 'C1').sort((a, b) => a.reach - b.reach)
      var a4a2 = a4Arr.filter(item => item.riskTypeCode === 'C2').sort((a, b) => a.reach - b.reach)
      var a4a3 = a4Arr.filter(item => item.riskTypeCode === 'C3').sort((a, b) => a.reach - b.reach)
      var a4a4 = a4Arr.filter(item => item.riskTypeCode === 'C4').sort((a, b) => a.reach - b.reach)
      var a4a5 = a4Arr.filter(item => item.riskTypeCode === 'C5').sort((a, b) => a.reach - b.reach)
      var a4ArrResult = a4a2.concat(a4a3, a4a1, a4a4, a4a5)
      let orgList = new Set()
      // 获取区达成排序
      for (let index = 0; index < this.tableAddArea.length; index++) {
        orgList.add(this.tableAddArea[index].areaCode)
      }
      // 根据orglist 进行排序
      let tabel = []
      let arrList = Array.from(orgList)
      for (let i = 0; i < arrList.length; i++) {
        const element = arrList[i]
        if (element === 864) {
          tabel.push(a4ArrResult)
        }
        if (element === 863) {
          tabel.push(a3ArrResult)
        }
        if (element === 862) {
          tabel.push(a2ArrResult)
        }
        if (element === 861) {
          tabel.push(a1ArrResult)
        }
      }
      // 将数组对象转成一个对象集合
      var tableMap = []
      tabel.map(function (value) {
        tableMap = tableMap.concat(value)
      })
      // order为false时，对数组数据进行反转
      if (!order) {
        tableMap.reverse()
      }
      // 拼接四个类型排序之后的数组，将数组按照顺序拼接即a2Arr,a3Arr,a1Arr,a4Arr-->年金险，健康险，人寿险，意外险
      return tableMap
    },
    // order为true带便升序，false代表降序,默认升序
    reachTable (arrayList, order) {
      // 对每个类型的数组按照类型指标riskTypeCode进行单个过滤之后进行sort排序,
      // A1,a1Arr表示人寿险，A2，a2Arr表示年金险，A3,a3Arr表示健康险，A4,a4Arr表示意外险
      let tableDataArr = []
      if (this.isHeadCompany()) {
        tableDataArr = arrayList
      } else {
        // 下钻直接排序
        if (this.pageSource === true) {
          tableDataArr = arrayList
        } else {
          if (this.pageNum === 1) {
            tableDataArr = arrayList
          } else {
            tableDataArr = this.childTable
          }
        }
      }
      let arrdata = []
      let typArr = JSON.parse(JSON.stringify(this.typeData))
      // 根据结构类型进行分类
      let areaSort = new Set([])
      typArr.forEach(item => {
        return areaSort.add(item.code)
      })
      let arraySourt = Array.from(areaSort)
      for (let index = 0; index < arraySourt.length; index++) {
        let test = JSON.parse(JSON.stringify(tableDataArr))
        let filterResult = test.filter(item => item.riskTypeCode === arraySourt[index]).sort((a, b) => a.reach - b.reach)
        if (!order) {
          filterResult.reverse()
        }
        arrdata = arrdata.concat(filterResult)
      }
      return arrdata
    },
    handleTheadAddClass (column) {
      // 判断找到当前列添加样式
      if (column.column.property === this.curThead) {
        return 'active-thead'
      }
    },
    getType () {
      if (this.$store.state.screens.riskType !== '') {
        let getTypeData = this.$store.state.screens.riskType
        this.typeLengthArr = getTypeData.split(',')
        this.typeLength = this.typeLengthArr.length
      } else {
        this.typeLengthArr = []
        for (let i = 0; i < this.typeData.length; i++) {
          this.typeLengthArr.push(this.typeData[i].code)
        }
        this.typeLength = this.typeLengthArr.length
      }
    },
    // 把数据拆分成组
    dealSortArr (sortData) {
      // var result = []
      // var chunk = this.typeLength // 每一个机构分一组
      // for (var i = 0, j = sortData.length; i < j; i += chunk) {
      //   result.push(sortData.slice(i, i + chunk))
      // }
      // return result
      var result = []
      let cutFlag = 0
      for (let i = 0; i <= sortData.length; i++) {
        if (i < sortData.length - 1 && sortData[i].orgName === sortData[i + 1].orgName) {
        } else {
          result.push((sortData.slice(cutFlag, i + 1)))
          cutFlag = i + 1
        }
        if (i === sortData.length - 1) {
          return result
        }
      }
    },
    // 把拆分成组的数据重新排列成数组
    realignSortArr (sortData) {
      let newArr = []
      for (let i = 0; i < sortData.length; i++) {
        for (let j = 0; j < sortData[i].length; j++) {
          newArr.push(sortData[i][j])
        }
      }
      return newArr
    },
    // 对每一类别的占比排序 返回整个数组
    proportionRealignArr (sortData, order) {
      if (order) {
        for (let i = 0; i < sortData.length; i++) {
          sortData[i].sort((a, b) => a.proportion - b.proportion)
        }
      } else {
        for (let i = 0; i < sortData.length; i++) {
          sortData[i].sort((a, b) => b.proportion - a.proportion)
        }
      }
      return sortData
    },
    // 3个月转正率占比排序
    rateProportionRealignArr (sortData, order) {
      for (let i = 0; i < sortData.length; i++) {
        sortData[i].sort((a, b) => a.proportion - b.proportion)
        if (!order) {
          sortData[i].reverse()
        }
      }
      return sortData
    },
    // 达成值数组数据
    rateReachRealignArr (sortData, order) {
      sortData.sort((a, b) => a[0].reach - b[0].reach)
      if (!order) {
        sortData.reverse()
      }
      return sortData
    },
    // 把数组按照达成额排序
    reachRealignArr (sortData, order) {
      let realignedArr = []
      for (let i = 0; i < this.typeLength; i++) {
        var typeArr = []
        for (let j = 0; j < sortData.length; j++) {
          if (sortData[j].riskTypeCode === this.typeLengthArr[i]) {
            typeArr.push(sortData[j])
          }
        }
        realignedArr[i] = typeArr
        realignedArr[i].sort((a, b) => a.reach - b.reach)
        if (!order) {
          realignedArr[i].reverse()
        }
      }
      realignedArr = this.realignSortArr(realignedArr)
      this.rowSpanFormatData(realignedArr, true)
    },
    isHeadCompany () {
      return this.$store.state.user.orgId === '86' || this.$store.state.user.areaFlag === '1'
    },
    getHomeInfo (filter) {
      console.log(this.pageNum)
      console.log(this.pageSource)
      this.pageNum = 0
      this.loadFlag = true
      let storeValue = {
        'screenOrg': this.$store.state.screens.screenOrg || '', // 机构筛选
        // 'riskType': this.$store.state.screens.riskType, // 类型筛选
        'reachStart': this.$store.state.screens.reachStart, // 达成范围起
        'reachEnd': this.$store.state.screens.reachEnd, // 达成范围止
        'proportionStrat': this.$store.state.screens.proportionStrat, // 占比范围起
        'proportionEnd': this.$store.state.screens.proportionEnd, // 占比范围止
        'checkedArea': this.$store.state.screens.checkedArea
      }
      if (this.postQuota === 'A0201-1002' || this.postQuota === 'A0202-1030' || this.postQuota === 'A0202-1028' || this.postQuota === 'A0202-1013' || this.postQuota === 'A0202-1023' || this.postQuota === 'A0202-1050' || this.postQuota === 'A0201-2061' || this.postQuota === 'A0202-2017') {
        storeValue.riskType = this.$store.state.screens.riskType
      } else {
        storeValue.riskType = this.$store.state.screens.period
      }
      let postDataParam = {
        'drillFlag': 0,
        'analyType': 2, // 分析类型, 1为机构分析,2 为结构分析, 3为 产品分析, 4为银行渠道分析, 5为百强中支
        'channelId': this.postChannel, // 渠道ID
        'classification': this.postKind, // 类ID
        'date': this.dateData || '', // 日期数据
        'dateType': this.timeIndex || '', // 日1 月2 年3
        'indexId': [this.postQuota],
        'key': '', // 主键
        'level': this.$store.state.user.level, // 层级
        'orgId': this.$store.state.user.orgId, // 机构ID
        'rank': 1, // 指标顺序排序
        'type': 1 // 请求类型, 1为总列表,2 为百强分支总列表, 3为 下级列表
      }
      let postData = postDataParam
      if (filter) {
        postData = {...postDataParam, ...storeValue}
      } else {
        this.$store.state.screens.riskType = '' // 类型筛选
        this.$store.state.screens.period = '' // 年期
        this.$store.state.screens.saleProduct = '' // 主销产品
        this.$store.state.screens.proportionEnd = '' // 占比范围止
        this.$store.state.screens.proportionStrat = '' // 占比范围起
        this.$store.state.screens.reachEnd = '' // 达成范围止
        this.$store.state.screens.reachStart = '' // 达成范围起
        this.$store.state.screens.screenOrg = '' // 机构筛选
        this.$store.state.screens.checkedArea = [] // 机构筛选
      }
      if (this.dateData && this.dateData !== '') {
        this.getData = postAction('/simpapp/structuralAnalysis/tabDataHis', postData)
      } else {
        this.getData = postAction('/simpapp/structuralAnalysis/tabData', postData)
      }
      this.getData.then((res) => {
        // 合计行
        this.totalRows = JSON.parse(JSON.stringify(res.data.tableData)).filter(num => num.isTotalLine === '1')
        this.one = JSON.parse(JSON.stringify(this.totalRows))
        this.oneCopy = JSON.parse(JSON.stringify(this.totalRows))
        // 展示包含系统合计行和东西南北四区以及机构数据
        this.tableDataAny = JSON.parse(JSON.stringify(res.data.tableData))
        // 展示东西南北四区合计
        this.tableAddArea = JSON.parse(JSON.stringify(res.data.areaData))
        // 过滤系统合计行之后的数据
        this.tableData = this.tableDataAny.filter(num => num.isTotalLine !== '1')
        let linshi = this.tableDataAny.filter(num => num.isTotalLine !== '1')
        this.tableDataSortByOrgCode = linshi.sort((a, b) => a.orgCode - b.orgCode)
        this.nameData = res.data.headerData
        this.typeData = res.data.typeData
        this.getType()
        // 筛选 趸交 3年以下 3-4年 5-9年 10年以上
        let {riskTypeCodeC1, riskTypeCodeC2, riskTypeCodeC3, riskTypeCodeC4, riskTypeCodeC5} = {
          riskTypeCodeC1: {
            orgName: '系统',
            riskTypeName: '趸交',
            reach: 0,
            proportion: 0,
            totall: 0 // 累计的总数
          },
          riskTypeCodeC2: {
            orgName: '系统',
            riskTypeName: '3年以下',
            reach: 0,
            proportion: 0,
            totall: 0
          },
          riskTypeCodeC3: {
            orgName: '系统',
            riskTypeName: '3-4年',
            reach: 0,
            proportion: 0,
            totall: 0
          },
          riskTypeCodeC4: {
            orgName: '系统',
            riskTypeName: '5-9年',
            reach: 0,
            proportion: 0,
            totall: 0
          },
          riskTypeCodeC5: {
            orgName: '系统',
            riskTypeName: '10年以上',
            reach: 0,
            proportion: 0,
            totall: 0
          }
        }
        let allTotall = 0 // 所有的总数
        // 过滤筛选区域
        if (Array.isArray(storeValue.checkedArea) && storeValue.checkedArea.length > 0) {
          this.tableAddArea = this.tableAddArea.filter(item => storeValue.checkedArea.includes(JSON.stringify(item.areaCode)))
          this.tableData = this.tableData.filter(item => storeValue.checkedArea.includes(JSON.stringify(item.areaCode)))
          this.tableData.forEach(item => {
            switch (item.riskTypeCode) {
              case 'C1':
                allTotall += item.reach
                riskTypeCodeC1.reach += item.reach
                break
              case 'C2':
                allTotall += item.reach
                riskTypeCodeC2.reach += item.reach
                break
              case 'C3':
                allTotall += item.reach
                riskTypeCodeC3.reach += item.reach
                break
              case 'C4':
                allTotall += item.reach
                riskTypeCodeC4.reach += item.reach
                break
              case 'C5':
                allTotall += item.reach
                riskTypeCodeC5.reach += item.reach
                break
            }
          })
          // 算每种类型在当前总和中所占的占比百分比
          riskTypeCodeC1.proportion = Math.round((riskTypeCodeC1.reach / allTotall) * 100)
          riskTypeCodeC2.proportion = Math.round((riskTypeCodeC2.reach / allTotall) * 100)
          riskTypeCodeC3.proportion = Math.round((riskTypeCodeC3.reach / allTotall) * 100)
          riskTypeCodeC4.proportion = Math.round((riskTypeCodeC4.reach / allTotall) * 100)
          riskTypeCodeC5.proportion = 100 - riskTypeCodeC1.proportion - riskTypeCodeC2.proportion - riskTypeCodeC3.proportion - riskTypeCodeC4.proportion - riskTypeCodeC5.proportion
        }
        // 截取出的区列是缺失的，需要强制添加空格占位，这样表格才不会错乱
        this.tableDataAny.forEach(element => {
          if (element.orgName === '系统') {
            element.areaName = ' '
          }
          element.areaName = element.areaSName
        })
        // 修改个险结构分析点击更多和下钻之后区列显示东西南北不带区字，遍历数组areaData重新给区列赋值
        const {orgId, areaFlag} = this.$store.state.user
        if ((orgId === '86' || areaFlag === '1')) {
          const areaData = res.data.tableData
          areaData.forEach(area => {
            // area.orgRiskId = area.areaSName
            area.areaName = area.areaSName
          })
        }
        if (this.isHeadCompany()) { // 是否显示区列
          this.tableAddArea.forEach(area => {
            area.orgName = area.areaName
            area.orgRiskId = 'area_' + area.orgRiskId
          })
          this.showTabledata = this.tableAddArea
        } else {
        // 分公司中支默认展示数据
          this.showTabledata = this.tableData
        }
        this.showDataStack = []
        // 如果数据条数超过5条隐藏其他只显示5条
        // this.changeTable()
        this.childShow = false
        this.loadFlag = false
        this.rowSpanFormatData(this.showTabledata)
      })
    },
    /*
    * 通过机构名称分解数组然后遍历数组中每个中文进行解析code
    * 再将每个code累加返回出去
    */
    getCharCode (orgName) {
      let nameArr = orgName.split('')
      let num = 0
      for (let i = 0; i < nameArr.length; i++) {
        num += Number(nameArr[i].charCodeAt())
      }
      return num
    },
    /*
    * 表格数据加载前对数据进行格式化处理
    */
    rowSpanFormatData (json, flag) {
      // this.showTabledata = JSON.parse(JSON.stringify(json))
      /*
      * 给json数据进行排序，把相同字段名称的机构放在一起
      * 此方法通过遍历机构中的中文名称的code码累加值进行排序
      * 后期如果返回数据是已经排好序的数据此段代码可注释掉
      */
      // if (json && json.length) {
      //   json.sort((r1, r2) => {
      //     let charCode1 = this.getCharCode(r1.orgName)
      //     let charCode2 = this.getCharCode(r2.orgName)
      //     return charCode1 - charCode2
      //   })
      // }
      /*
       * 通过倒序遍历将循环中的数据相同的字段名称增加rowspan
       * 只给最后末尾的增加
       */
      if (this.childShow) {
        this.rowSpanFormatMoreData(this.showMoreType === 2 ? this.getTotal(json) : json)
        return
      }
      let j = 1
      for (let i = json.length - 1; i >= 0; i--) {
        // 每次相同就让j++要是最后i==0 直接赋值就可以了
        if (i > 0 && json[i].orgName === json[i - 1].orgName) {
          j++
          delete json[i].rowspan
          // 每次不同需要就可以赋值给rowspan字段了
        } else {
          json[i].rowspan = j
          j = 1
        }
        if (flag) {
          delete json[i].rowspan
          json[i].rowspan = 1
        }
      }
      // return json
      this.showData = json
      this.popData = json
    },
    // 合并列的方法此方法为element中方法
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'orgName') {
        if (row.rowspan && row.rowspan > 1) {
          return { // 需要合并的行数
            rowspan: row.rowspan,
            colspan: 1
          }
        } else if (!row.rowspan) {
          return { // 当没有rowspan字段的行合并空行会去掉原本的相同字段名称
            rowspan: 0,
            colspan: 0
          }
        }
      }
      if (column.property === 'areaName') {
        if (row.areaRowspan && row.areaRowspan > 1) {
          return { // 需要合并的行数
            rowspan: row.areaRowspan,
            colspan: 1
          }
        } else if (!row.areaRowspan) {
          return { // 当没有rowspan字段的行合并空行会去掉原本的相同字段名称
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    load (tree, treeNode, resolve) {
      console.log(this.pageNum)
      console.log(this.pageSource)
      this.loadFlag = true
      if (tree.nextLevel === 2 && treeNode.loaded === false && treeNode.expanded === true) {
        this.$refs.structureTable1.toggleRowExpansion(tree, false)
        treeNode.loading = false
        return
      }
      if (tree.orgRiskId.slice(0, 5) === 'area_') {
        this.pageNum = 1
        treeNode.loading = false
        this.loadFlag = false
        this.isBack = true
        this.shouqi = false
        this.childShow = true
        // 直接点击下钻，则将下钻之后的数据进行遍历，将SName赋值给区列areaName,然后rowSpan展示数据
        this.tableData.forEach(area => {
          area.areaName = area.areaSName
        })
        this.rowSpanFormatData(this.tableDataAny)
        return
      }
      // 如果pagenum=0 则为直接点击下钻
      if (this.pageNum === 0) {
        // 如果为分公司不下钻
        if (!this.isHeadCompany()) {
          this.pageNum = 0
          this.isLoadInto = true
          // this.childShow = true
        } else {
          this.pageNum = 1
        }
      } else {
        this.pageNum = 2
        // 如果是总公司
        // if (this.isHeadCompany()) {
        this.shouqi = false
        // }
      }
      let treeData = []
      let childPostData = {
        'drillFlag': 1,
        'analyType': 2, // 分析类型, 1为机构分析,2 为结构分析, 3为 产品分析, 4为银行渠道分析, 5为百强中支
        'channelId': this.postChannel, // 渠道ID
        'classification': this.postKind, // 类ID
        'date': this.dateData || '', // 日期数据
        'dateType': this.timeIndex || '', // 日1 月2 年3
        'indexId': [this.postQuota],
        'key': '', // 主键
        'level': tree.nextLevel, // 层级
        'orgId': tree.orgCode, // 机构ID
        'rank': 1, // 指标顺序排序
        'type': 1, // 请求类型, 1为总列表,2 为百强分支总列表, 3为 下级列表
        'screenOrg': tree.orgCode, // 机构ID
        'screenOrgNext': this.$store.state.screens.screenOrg || '', // 机构筛选
        // 'riskType': this.$store.state.screens.riskType,
        'reachStart': this.$store.state.screens.reachStart || '',
        'reachEnd': this.$store.state.screens.reachEnd || '',
        'proportionStrat': this.$store.state.screens.proportionStrat || '',
        'proportionEnd': this.$store.state.screens.proportionEnd || ''
      }
      if (this.postQuota === 'A0201-1002' || this.postQuota === 'A0202-1030' || this.postQuota === 'A0202-1028' || this.postQuota === 'A0202-1013' || this.postQuota === 'A0202-1023' || this.postQuota === 'A0202-1050' || this.postQuota === 'A0201-2061' || this.postQuota === 'A0202-2017') {
        childPostData.riskType = this.$store.state.screens.riskType
      } else {
        childPostData.riskType = this.$store.state.screens.period
      }
      if (this.dateData && this.dateData !== '') {
        this.getData = postAction('/simpapp/structuralAnalysis/tabDataHis', childPostData)
      } else {
        this.getData = postAction('/simpapp/structuralAnalysis/tabData', childPostData)
      }
      this.getData.then((res) => {
        treeData = res.data.tableData
        treeData.forEach(row => {
          row.areaName = row.areaSName
        })
        // this.rowSpanFormatData(treeData) // 合并列方法
        this.childTable = treeData
        this.showMoreType = 1
        this.rowSpanFormatData(this.childTable)
        treeNode.loaded = false
        this.loadFlag = false
        // resolve(treeData) // 进行数据加载
        if (tree.nextLevel === 2) {
          treeNode.loaded = false // 加载完成后将加载状态置为 false
        }
        this.isBack = true
      })
    },
    closeExpanded () {
      for (let i = 0; i < this.showData.length; i++) {
        try {
          this.$refs.structureTable1.toggleRowExpansion(this.showData[i], false)
        } catch (err) {
        }
      }
    },
    childByValue (childValue, closeFlag) {
      // childValue就是子组件传过来的值
      if (!closeFlag) {
        this.getHomeInfo(true)
      }
      this.show = childValue
      this.closeExpanded()
    },
    showPopup () {
      this.show = true
    },
    rowSpanFormatMoreData (json, colName = 'areaName') {
      /*
       * 通过倒序遍历将循环中的数据相同的字段名称增加rowspan
       * 只给最后末尾的增加
       */
      const rowspanName = colName === 'areaName' ? 'areaRowspan' : 'rowspan'
      let j = 1
      for (let i = json.length - 1; i >= 0; i--) {
        // 每次相同就让j++要是最后i==0 直接赋值就可以了
        if (i > 0 && json[i][colName] === json[i - 1][colName]) {
          j++
          delete json[i][rowspanName]
          // 每次不同需要就可以赋值给rowspan字段了
        } else {
          if (colName === 'areaName') {
            json.splice(i, j, ...this.rowSpanFormatMoreData(json.slice(i, i + j), 'orgName'))
          }
          json[i][rowspanName] = j
          j = 1
        }
      }
      this.showData = json
      return json
    },
    getTotal (data) {
      const totalRow = JSON.parse(JSON.stringify(this.totalRows))
      totalRow.forEach(row => {
        row.orgRiskId = `total__${row.riskTypeCode}`
        row.reach = 0
      })
      data.forEach(row => {
        const index = totalRow.findIndex(r => r.riskTypeCode === row.riskTypeCode)
        if (~index) {
          totalRow[index].reach += row.reach
        }
      })
      data.unshift(...totalRow)
      return data
    },
    // 总公司登录展示带合计行四区以及机构，分公司登录只显示分公司机构，不带合计行和四区
    showMore (isTotal = true, isshowMore = true, isLoad = false) {
      console.log(this.pageNum)
      console.log(this.pageSource)
      this.pageSource = false
      this.pageNum = 1
      if (isLoad) {
        this.isBack = true
        this.shouqi = false
      } else {
        this.shouqi = true
        this.isBack = false
      }
      this.childShow = true
      this.sequenceOrder = 'null'
      // 总公司、区总
      if (this.isHeadCompany()) {
        // this.showTabledata = this.tableDataAny
        if (isshowMore) {
          let sortData = this.totalRows.concat(JSON.parse(JSON.stringify(this.tableData)).sort((a, b) => {
            if (a.orgCode !== b.orgCode) {
              return a.orgCode - b.orgCode
            } else {
              a.riskTypeCode.localeCompare(b.riskTypeCode)
            }
          }))
          sortData.forEach(item => {
            item.areaName = item.areaSName
            if (item.orgName === '系统' || item.orgName === null) {
              item.areaName = ' '
            }
          })
          this.rowSpanFormatMoreData(sortData)
          return
        }
        this.showTabledata.forEach(row => {
        // 从展示表格充找出areaSName
          row.areaName = row.areaSName
        })
        this.rowSpanFormatMoreData(this.showTabledata)
      } else {
        // 分公司中支
        this.rowSpanFormatData(this.tableData)
      }
    },
    // 收起
    back () {
      this.childShow = false
      this.shouqi = false
      this.isBack = false
      this.pageSource = true
      this.pageNum = 0
      this.sequenceOrder = 'null'
      // 判断一下当前所在页面展示的数据然后重新填充数据
      if (this.isHeadCompany()) {
        this.rowSpanFormatData(this.tableAddArea)
      } else {
        this.rowSpanFormatData(this.tableData)
      }
      this.closeExpanded()
    },
    // 返回
    backMore () {
      if (this.pageNum === 2) {
        this.childShow = true
        // 是否是下钻
        if (this.pageSource) {
          // 分公司用户
          if (!this.isHeadCompany()) {
            this.rowSpanFormatData(this.tableData)
            this.shouqi = true
            this.isBack = false
          } else {
            this.rowSpanFormatData(this.tableDataAny)
            this.shouqi = false
            this.isBack = true
          }
        } else {
          // 如果是总公司需要返回合计行
          if (this.isHeadCompany()) {
            let data = JSON.parse(JSON.stringify(this.tableData)).sort((a, b) => a.orgCode - b.orgCode)
            this.rowSpanFormatData(this.one.concat(data))
          } else {
            this.rowSpanFormatData(this.tableDataAny.sort((a, b) => a.orgCode - b.orgCode))
          }
          this.shouqi = true
          this.isBack = false
        }
        this.isLoadInto = false
        this.pageNum = 1
        return
      }
      // 如果为分公司 返回pageNum应该为0(
      if (!this.isHeadCompany()) {
        this.pageNum = 0
        this.isLoadInto = false
      } else {
        this.pageNum = 1
      }
      this.isBack = false
      this.pageSource = true
      this.sequenceOrder = 'null'
      this.childShow = false
      // 判断是总公司和区域总登录 返回表格展示四区tableAddArea,分公司展示分公司数据tableData
      if (this.isHeadCompany()) {
        this.showTabledata = this.tableAddArea
        this.pageNum = 0
      } else {
        this.showTabledata = this.tableData
      }
      this.rowSpanFormatData(this.showTabledata)
      this.closeExpanded()
    },
    changeTable () {
      this.moreText = '查看更多'
      // this.popData = JSON.parse(JSON.stringify(this.showData))
      // this.listData = []
      // if (this.showTabledata.length > 5) {
      //   this.moreFlag = true
      //   for (let i = 0; i < 5; i++) {
      //     this.listData.push(this.showTabledata[i])
      //   }
      //   this.showData = this.listData
      // } else {
      //   this.moreFlag = false
      //   this.showData = this.showTabledata
      // }
    }
  },
  mounted () {
    try {
      this.$refs.screen.clearSelectedBranchs()
    } catch (err) {
    }
    this.postChannel = this.$store.state.entirety.channel
    this.postKind = this.$store.state.entirety.kind
    this.postQuota = this.$store.state.entirety.quota
    this.popHeight = document.documentElement.clientHeight - 40
    if (this.timeIndex) {
      this.tableHeight = 'calc(100vh - 202px)'
      this.getHomeInfo()
    }
  },
  watch: {
    timeIndex () {
      this.$nextTick(() => {
        if (this.timeIndex === 2) {
          this.tableHeight = 'calc(100vh - 202px)'
        } else {
          this.tableHeight = 'calc(100vh - 225px)'
        }
        try {
          this.$refs.screen.clearSelectedBranchs()
        } catch (err) {
        }
        this.closeExpanded()
        this.getHomeInfo()
      })
    },
    dateData () {
      this.$nextTick(() => {
        try {
          this.$refs.screen.clearSelectedBranchs()
        } catch (err) {
        }
        this.closeExpanded()
        this.getHomeInfo()
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .el-table::before{
        height: 0 !important;
  }
  >>>table.el-table__header{
    width: 100%;
  }
  >>>table.el-table__body{
    width: 100%;
  }
  /deep/.el-table__row{
    width: 100%;
    height: 0.53rem;
  }
  >>>.tableList5{
    // max-height: 4.65rem;
    overflow: hidden;
    margin-bottom: 0.4rem
  }
  .table {
    position: relative;
  }
  .table-warpper{
    margin-top: 0.1rem;
    padding: 0px 15px;
    background: #fff;
  }
  .table-itme>>>.el-table__expand-icon{
    float : left;
  }
  .table-itme>>>td,.table-itme>>>th{
    // border-right: none;
    text-align : center;
  }
  .table-itme>>>span.el-table__indent{
    padding-left : 0!important;
  }
  .table-itme>>>tr.el-table__row.el-table__row--level-1{
    background : #F9F9F9;
  }
  .table-itme>>>.el-table__expand-icon{
    margin-right: -25px;
  }
  // .table-itme>>>tr.el-table__row.el-table__row--level-1:nth-child(0) .cell{
  //   margin-right: 20px
  // }
  .table-itme>>>span.el-table__placeholder{ // 不同级别缩进相同(不分等级级别对齐)
    width : 0;
  }
  .table-itme>>>tr.el-table__row.el-table__row--level-2 {
      background: #eee;
  }
  .van-popup.van-popup--center{
    width : 90%;
    // height : 60%;
    border-radius : .06rem;
    background #fff;
  }
  .table-title,.table-icon{
    font-size: 0.18rem;
    font-weight: 600;
    height: 0.45rem;
    line-height: 0.45rem;
  }
  .table-title1{
    font-size: 0.14rem;
    height: 0.34rem;
    margin-bottom:0.1rem
  }
  .table-icon{
    text-align : right;
  }
  .table-itme>>>.el-table__expanded-cell{
    padding: 0;
    padding-left: 48px;
  }
  .table-itme>>>.el-form--inline .el-form-item__content{
    padding-left: 4px;
    padding-right: 4px;
  }
  .table-itme>>>.cell{
    padding-left: 4px !important;
    padding-right: 4px !important;
  }
  .table-itme>>>td.el-table__expanded-cell{
    background: #F9F9F9;
  }
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .demo-table-expand{
    display: flex;
  }
  .more{
    width:100%;
    line-height:.4rem;
    text-align: center;
    color:#3399FF;
    background: #ffffff;
    font-size: .14rem;
    border-bottom: 1px solid #EBEEF5;
    position:fixed;
    bottom:0
  }
  .changeColor{
    color:#3399FF;
    font-size: .18rem
  }
  .table-title1 div{
    height: 0.34rem;
    display:table-cell;
    vertical-align:bottom
  }
  .fixTop{
    width:100%;
    height:100vh;
    position : fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    z-index:999999999;
  }
  >>>colgroup{
    overflow: hidden;
    display: none;
  }
  .showImg{
    position flex
    z-index 999999999999999
  }
</style>



// WEBPACK FOOTER //
// src/pages/entirety/components/PerStructureTable.vue